import React from "react";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Popover from "./Popover";
import magazine from "../../../assets/images/magazine.png";
import useMediaQuery from "@mui/material/useMediaQuery";

const magazines = [
  { date: "April 2021", caption: "Exclusive interview of Euro Auction." },
  {
    date: "January 2021",
    caption: "This text will grow till here. The width will be 200px.",
  },
  {
    date: "October 2020",
    caption:
      "What ever the copy will be here. It will have around 68 characters.",
  },
  { date: "July 2020", caption: "Exclusive interview of Euro Auction." },
  { date: "April 2020", caption: "Exclusive interview of Euro Auction." },
];

function Magazine({ date, caption }) {
  return (
    <Container
      disableGutters
      sx={{
        width: "200px",
        "&:hover": {
          cursor: "pointer",
        },
        "&:hover img": {
          height: "177px",
          filter:
            "drop-shadow(0px 4px 5px rgba(0, 0, 0, 0.14)) drop-shadow(0px 1px 10px rgba(0, 0, 0, 0.12)) drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.2))",
        },
      }}
    >
      <Box
        sx={{
          width: "120px",
          height: "169px",
        }}
      >
        <img src={magazine} alt="magazine" style={{ objectFit: "cover" }} />
      </Box>
      <Box sx={{ height: "16px" }} />
      <Typography
        variant="subtitle2"
        fontWeight="600"
        fontSize="14px"
        lineHeight="20px"
      >
        {date}
      </Typography>
      <Box sx={{ height: "4px" }} />
      <Typography
        variant="caption"
        fontWeight="400"
        fontSize="12px"
        lineHeight="16px"
      >
        {caption}
      </Typography>
    </Container>
  );
}

function Magazines() {
  const tabMatch = useMediaQuery("(max-width:900px)");
  return (
    <Popover label="Magazines">
      <Typography
        variant="subtitle2"
        fontWeight="600"
        fontSize="14px"
        lineHeight="20px"
      >
        Our Magazines
      </Typography>
      <Container
        disableGutters
        sx={{
          marginTop: "24px",
          display: "flex",
          flexWrap: { sm: "wrap", md: "nowrap" },
          columnGap: { sm: "24px", md: "40px" },
          rowGap: { sm: "24px", md: "0px" },
        }}
      >
        {tabMatch
          ? magazines
              .slice(0, 3)
              .map((m) => <Magazine date={m.date} caption={m.caption} />)
          : magazines.map((m) => (
              <Magazine date={m.date} caption={m.caption} />
            ))}
      </Container>
    </Popover>
  );
}

export default Magazines;
